import { render } from "./Tab.vue?vue&type=template&id=30866dd8&scoped=true"
import script from "./Tab.vue?vue&type=script&lang=js"
export * from "./Tab.vue?vue&type=script&lang=js"

import "./Tab.vue?vue&type=style&index=0&id=30866dd8&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-30866dd8"

export default script